import { render } from "./KpiSearch.vue?vue&type=template&id=f148c7f2"
import script from "./KpiSearch.vue?vue&type=script&lang=js"
export * from "./KpiSearch.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__